module.exports = __webpack_public_path__ + "resources/img/img_dvision5.a135d5bfe930eeca42a462cc6a93b0e7.png";